import axios, { AxiosResponse } from 'axios';
import { polyfill } from 'es6-promise';
import { IApiResponse } from "../interfaces/IApiResponse";
import IUser from '../interfaces/IUser';
import { ICategorie } from '../interfaces/ICategorie';
declare var configcustoms: any;


export default class DataProvider {

    private serverWSURL: string = configcustoms.UrlAPI;
    private apiUser: string = configcustoms.API.User;
    private apiVerifUserKey: string = configcustoms.API.VerifUserKey;
    private apiRenewUserPassword: string = configcustoms.API.RenewUserPassword;
    private apiVerifRenewPasswordKey: string = configcustoms.API.VerifRenewPasswordKey;
    private apiValidationCandidature: string = configcustoms.API.ValidationCandidature;
    private apiDownloadPdfCandidature: string = configcustoms.API.DownloadPdfCandidature;

    constructor() {
        polyfill();
    }

    public async createUser(user: IUser): Promise<IApiResponse<string>> {
        let rtn: IApiResponse<string> = { State: '', Message: '', Content: '' };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiUser,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: user
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.State = "KO";
            rtn.Message = error;
            return rtn;
        }
    }

    public async renewPassword(user: IUser): Promise<IApiResponse<string>> {
        let rtn: IApiResponse<string> = { State: '', Message: '', Content: '' };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiRenewUserPassword,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: user
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.State = "KO";
            rtn.Message = error;
            return rtn;
        }
    }

    public async activateUser(user: IUser): Promise<IApiResponse<IUser>> {
        const userInit: IUser = {
            Email: '',
            FirstName: '',
            Key: '',
            LastName: '',
            Password: '',
            Login: ''
        }
        let rtn: IApiResponse<IUser> = { State: '', Message: '', Content: userInit };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiUser,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'put',
                data: user
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.State = "KO";
            rtn.Message = error;
            return rtn;
        }
    }

    public async verifyUserKey(user: IUser): Promise<IApiResponse<IUser>> {
        const userInit: IUser = {
            Email: '',
            FirstName: '',
            Key: '',
            LastName: '',
            Password: '',
            Login: ''
        }
        let rtn: IApiResponse<IUser> = { State: '', Message: '', Content: userInit };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiVerifUserKey,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: user
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.State = "KO";
            rtn.Message = error;
            return rtn;
        }
    }

    public async verifyRenewPasswordKey(user: IUser): Promise<IApiResponse<IUser>> {
        const userInit: IUser = {
            Email: '',
            FirstName: '',
            Key: '',
            LastName: '',
            Password: '',
            Login: ''
        }
        let rtn: IApiResponse<IUser> = { State: '', Message: '', Content: userInit };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiVerifRenewPasswordKey,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: user
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.State = "KO";
            rtn.Message = error;
            return rtn;
        }
    }

    public async renewPasswordValidation(user: IUser): Promise<IApiResponse<IUser>> {
        const userInit: IUser = {
            Email: '',
            FirstName: '',
            Key: '',
            LastName: '',
            Password: '',
            Login: ''
        }
        let rtn: IApiResponse<IUser> = { State: '', Message: '', Content: userInit };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiRenewUserPassword,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'put',
                data: user
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.State = "KO";
            rtn.Message = error;
            return rtn;
        }
    }

    public async validationCandidatureSendPdf(loginName: string, idCandidature: number, categorieList: ICategorie[]): Promise<IApiResponse<string>> {
        let rtn: IApiResponse<string> = { State: '', Message: '', Content: '' };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiValidationCandidature,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: {
                    LoginName: loginName,
                    IDCandidature: idCandidature,
                    CategorieList: categorieList
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.State = "KO";
            rtn.Message = error;
            return rtn;
        }
    }

    public async downloadPdfCandidature(loginName: string, idCandidature: number | string, categorieList: ICategorie[], fileName: string): Promise<any> {
        const FileSaver = require('file-saver');

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiDownloadPdfCandidature,
                headers: { 'Access-Control-Allow-Origin': window.location.href, },
                responseType: 'blob',
                method: 'post',
                data: {
                    LoginName: loginName,
                    IDCandidature: idCandidature,
                    CategorieList: categorieList
                }
            });

            // Create blob with mime type pdf
            const file = new Blob([resp.data], { type: 'application/pdf' });            
            return FileSaver.saveAs(file, fileName + '.pdf');
        }
        catch (error) {
            return 'Error download';
        }
    }
}
